import {BaseService} from "./base.service";

class SubsidiaryService extends BaseService {

    constructor() {
        super('api/subsidiary-for-supplier');
    }


}

export const subsidiaryService = new SubsidiaryService();
